/* eslint-disable implicit-arrow-linebreak */
import { useMutation } from '@tanstack/react-query';

import { AlertAdapter } from 'pg-ui-library';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IDependent } from 'src/interfaces';
import EmployeesService from 'src/services/employees.service';

export const useAddDependentToEmployee = () => {
  const { getEmployeeDependents } = useActions();
  const { selectedEmployee } = useTypedSelector(state => state.employees.data);
  const { config } = useTypedSelector(state => state.config.data);

  const employeeId = selectedEmployee.employee?.id || '';
  const companyId = config?.selectedCompanyId || '';
  const mutation = useMutation(
    (data: { dependent: IDependent; params: { companyId: string; personnelNumber: string } }) =>
      EmployeesService.postEmployeeDependent(data.dependent, data.params),
    {
      onSuccess: () => {
        getEmployeeDependents({ page: 1, companyId, limit: 10, employeeId });
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
  return mutation;
};
